import { PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridExcelStyles, PxdAgGridFilterParams, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions, PXDDefaultExcelExportParams } from '@app/shared/aggrid/pxd-ag-grid-options';

export class ScheduleTaskGridOptions {

  public isAllowedToEditSchedule = false;

  dateComparator(date1: any, date2: any) {
    const date1Value = new Date(date1);
    const date2Value = new Date(date2);

    if (date1Value < date2Value) {
      return -1;
    } else if (date1Value > date2Value) {
      return 1;
    } else {
      return 0;
    }
  }

  public gridOptions: PxdAgGridOptions = {
    tooltipShowDelay: 0,
    enableCharts: true,
    cellSelection: true,
    rowGroupPanelShow: 'always',
    defaultColDef: PxdAgEditGridDefaultColumnDef,
    statusBar: PxdAgGridStatusBarOptions,
    sideBar: PxdAgGridSideBarOptions,
    columnTypes: PxdAgGridColumnTypes,
    excelStyles: PxdAgGridExcelStyles,
    defaultExcelExportParams: PXDDefaultExcelExportParams,
    columnDefs: [
      {
        field: 'Phase', headerName: 'Phase', flex: 1, editable: false
      },
      {
        field: 'Step', headerName: 'Step', flex: 1, editable: false
      },
      {
        field: 'ActiveDuration',
        editable: () => {
          return this.isAllowedToEditSchedule;
        },
        valueFormatter: params => (+params.value).toFixed(2),
        aggFunc: 'sum',
        headerTooltip: 'PlannedDuration - IdleDuration',
        type: ['numberColumn'],
        flex: 1
      },
      {
        field: 'PlannedStartDate',
        headerName: 'Start',
        type: ['dateColumn'],
        flex: 1,
        editable: params => {
          return this.isAllowedToEditSchedule;
        },
        comparator: this.dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: PxdAgGridFilterParams.customDate
      },
      {
        field: 'PlannedEndDate',
        headerName: 'End',
        type: ['dateColumn'],
        flex: 1,
        editable: false,
        comparator: this.dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: PxdAgGridFilterParams.customDate
      }
    ]
  };
}